import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import DefaultFAQ from "src/pages/default-overview/default-faq/DefaultFaqPageIndex";
import ACHErrorPage from "src/pages/achEnrollment/ACHErrorPage";
import ThanksForEnroll from "src/pages/achEnrollment/ThanksForEnrolling";
import SessionTimeoutPage from "src/pages/achEnrollment/ach-session-timeout/SessionTimeoutPage";
import AchEnrollment from "src/pages/achEnrollment";

import { useSelector } from "react-redux";
import ExisitingSession from "src/pages/achEnrollment/ExisitingSession";

const Home = lazy(() => import("src/pages/how-it-works/HowItWorksPageIndex"));
const PaymentTerms = lazy(
  () => import("src/pages/payment-terms/PaymentTermPageIndex")
);
const Faqs = lazy(() => import("src/pages/faqs/FaqPageIndex"));
const DefaultOverview = lazy(
  () => import("src/pages/default-overview/DefaultOverviewIndex")
);
const EnrollVCN = lazy(() => import("src/pages/enroll-vcn/EnrollVcn"));

export const pagePath = {
  paymentTerm: "/payment-term",
  faq: "/faqs",
  defaultOverview: "/defaultOverview",
  enrollVCN: "/enrollvcn",
  defaultFAQ: "/defaultOverview/defaultfaq",
  errorPage: "/errorPage",
  thanksPage: "/thanks",
  sessionPage: "/session-timeout",
  achDefaultEmailPage: "/ach",
  exisistingSessionPage: "/existing-session"
};

const Routers = () => {
  const ACHData = useSelector(
    (state: any) => state.getSecData.value?.secDataDetails
  );

  const targetEnrollment = ACHData?.content?.contentTargetEnrollment;

  return (
    <>
      <Suspense>
        <div>
          <Routes>
            {targetEnrollment === "ACH" ? (
              <>
                <Route path="/" element={<AchEnrollment />} />
                <Route
                  path={pagePath.achDefaultEmailPage}
                  element={<AchEnrollment />}
                />
              </>
            ) : (
              <Route path="/" element={<Home />} />
            )}

            <Route path="/defaultOverview" element={<DefaultOverview />} />
            <Route path={pagePath.paymentTerm} element={<PaymentTerms />} />
            <Route path={pagePath.faq} element={<Faqs />} />
            <Route path={pagePath.enrollVCN} element={<EnrollVCN />} />
            <Route path={pagePath.defaultFAQ} element={<DefaultFAQ />} />
            <Route path={pagePath.errorPage} element={<ACHErrorPage />} />
            <Route path={pagePath.exisistingSessionPage} element={<ExisitingSession/>}/>
            <Route path={pagePath.thanksPage} element={<ThanksForEnroll />} />
            <Route
              path={pagePath.sessionPage}
              element={<SessionTimeoutPage />}
            />
          </Routes>
        </div>
      </Suspense>
    </>
  );
};

export default Routers;
